var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 290,
    viewBox: "0 0 334 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.527 165.033L114.378 94.6071C126.305 63.3256 155.758 42.1885 189.212 40.903L207.651 40.1945L145.28 187.236L87.527 165.033Z",
    fill: "#F0F3F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.586 39.4491L190.144 40.0881C156.686 41.2474 127.154 62.2734 115.109 93.5097L87.9923 163.834L145.661 186.255L208.586 39.4491ZM183.885 56.6038C159.675 59.9057 138.905 76.1162 129.986 99.2462L108.59 154.735L137.076 165.81L183.885 56.6038Z",
    fill: "#00322E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.582 215.417C284.463 216.194 286.32 214.259 285.466 212.411L268.322 175.303C267.481 173.482 264.853 173.603 264.183 175.494L254.9 201.698C254.502 202.821 255.054 204.058 256.155 204.513L282.582 215.417Z",
    fill: "#00322E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.412 230.123C271.068 231.305 273.315 229.84 272.902 227.848L264.606 187.821C264.199 185.857 261.612 185.38 260.531 187.07L245.556 210.491C244.914 211.494 245.171 212.825 246.141 213.517L269.412 230.123Z",
    fill: "#00322E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.162 248.282L128.445 209.327L142.959 202.726L163.678 248.282H146.162ZM138.687 248.282L123.493 214.875L108.979 221.476L121.17 248.282H138.687Z",
    fill: "#00322E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3024 78.1459L32.7718 96.0494C40.8804 128.531 67.6008 153.031 100.662 158.3L175.094 170.161L185 109.085L28.3024 78.1459Z",
    fill: "#F0F3F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3024 78.1459L32.7718 96.0494C40.8804 128.531 67.6008 153.031 100.662 158.3L175.094 170.161L185 109.085L28.3024 78.1459ZM50.2294 98.7278C58.5056 121.718 78.6898 138.653 103.171 142.554L161.901 151.912L166.794 121.743L50.2294 98.7278Z",
    fill: "#00322E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9239 78.0351L77.6434 215.953L230.235 240.604L287.271 179.06L252.515 102.686L99.9239 78.0351Z",
    fill: "#F0F3F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.346 223.501L268.363 176.005L241.54 117.065L113.122 96.3187L95.927 202.756L224.346 223.501ZM230.235 240.604L287.271 179.06L252.515 102.686L99.9239 78.0351L77.6434 215.953L230.235 240.604Z",
    fill: "#00322E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.991 178.812C206.36 171.733 207.525 161.416 214.593 155.769C221.661 150.121 231.955 151.281 237.586 158.36C243.217 165.439 242.052 175.756 234.984 181.404C227.916 187.052 217.621 185.891 211.991 178.812Z",
    fill: "#F0F3F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.131 171.517C219.282 169.192 219.664 165.803 221.986 163.948C224.307 162.093 227.689 162.474 229.538 164.799C231.388 167.124 231.005 170.513 228.683 172.368C226.362 174.223 222.981 173.842 221.131 171.517Z",
    fill: "#F0F3F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.865 175.106C209.234 168.027 210.399 157.71 217.467 152.062C224.535 146.415 234.829 147.575 240.46 154.654C246.091 161.733 244.926 172.05 237.858 177.698C230.79 183.345 220.495 182.185 214.865 175.106Z",
    fill: "#00322E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.008 167.811C222.159 165.486 222.541 162.098 224.863 160.242C227.184 158.387 230.565 158.769 232.415 161.094C234.264 163.419 233.882 166.808 231.56 168.663C229.239 170.518 225.857 170.136 224.008 167.811Z",
    fill: "#F0F3F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.421 172.653C220.572 170.328 220.954 166.939 223.276 165.084C225.597 163.229 228.978 163.61 230.828 165.935C232.677 168.26 232.295 171.649 229.973 173.504C227.652 175.359 224.27 174.978 222.421 172.653Z",
    fill: "#00322E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.041 183.883C190.125 171.085 199.22 129.978 175.529 104.84L93.4824 17.7832C63.197 84.3592 70.2609 122.444 85.6462 156.512C97.7886 183.399 130.639 194.813 158.041 183.883Z",
    fill: "#F0F3F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4824 17.7832C90.9635 23.3204 88.703 28.6606 86.6842 33.8177C64.4296 90.6666 71.5405 125.278 85.6462 156.512C97.7886 183.399 130.639 194.813 158.041 183.883C190.125 171.085 199.22 129.978 175.529 104.84L93.4824 17.7832ZM98.8646 46.7419C91.3073 67.845 88.4456 84.9375 88.3824 99.4078C88.2989 118.518 93.0847 134.243 100.178 149.949C108.447 168.26 131.808 177.18 152.133 169.073C173.767 160.443 179.9 132.725 163.925 115.775L98.8646 46.7419Z",
    fill: "#00322E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.598 125.492C126.794 129.508 122.076 131.302 118.059 129.498C94.2881 118.821 73.5769 92.0445 79.073 57.5322C79.7655 53.184 83.8518 50.2204 88.2 50.9129C92.5482 51.6053 95.5118 55.6916 94.8193 60.0398C90.6491 86.2263 106.199 106.691 124.592 114.953C128.609 116.757 130.402 121.475 128.598 125.492Z",
    fill: "#00322E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M322.98 271.817L307.103 255.94L314.62 248.424L333.948 267.752L322.98 271.817Z",
    fill: "#FFBEB4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M293.365 284.543L293.365 262.09L303.995 262.09L303.995 289.424L293.365 284.543Z",
    fill: "#FFBEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/Bird.8755415f46cdc8159f8256c76b75e57f.svg";
export { ForwardRef as ReactComponent };